Namespace('Monitoring.SharedSessions.SharedSessionContainer')

class Monitoring.SharedSessions.SharedSessionContainerView extends Backbone.View
  template: JST["backbone/templates/monitoring/shared_sessions/shared_session_container"]
  className: 'shared-session-container'

  events:
    'change #autorefresh-period': 'onChangeAutorefreshPeriod'
    'click .refresh-button': 'onClickRefresh'
    'click .filter-button': 'onClickFilter'

  initialize: (@options = {}) ->
    @sharedSessionData = @options.sharedSessionData
    @searchQuery = new Monitoring.Models.SearchQuery(@options.searchQuery, { use_defaults: false })
    @total = @options.total
    @uniqueUsers = @options.uniqueUsers
    @facets = @options.facets
    @postFacets = @options.postFacets
    @tagsByClientCode = @options.tagsByClientCode
    @accountData = @options.accountData
    @sidebarView = new Monitoring.SharedSessions.SharedSessionSidebarView(filtersViewOptions: @getFiltersViewOptions())
    @autorefreshPeriod = 0

  render: ->
    @$el.html(@template({
      sharedSessionData: @sharedSessionData
      accountData: @accountData
      total: @total
      uniqueUsers: @uniqueUsers
    }))
    @renderCharts()
    @$el.prepend(@sidebarView.render().$el)
    @

  renderCharts: ->
    @chartsView = new Monitoring.SharedSessions.SharedSessionChartsView({
      searchQuery: @searchQuery
      total: @total
      uniqueUsers: @uniqueUsers
      facets: @facets
      tagsByClientCode: @tagsByClientCode
    })
    @$el.find('.shared-session-charts-container').html(@chartsView.render().$el)

  onChangeAutorefreshPeriod: ->
    @autorefreshPeriod = @$el.find('#autorefresh-period').val()
    @resetAutorefreshInterval()

  resetAutorefreshInterval: ->
    clearInterval(@autorefreshInterval) if @autorefreshInterval
    if @autorefreshPeriod > 0
      @autorefreshInterval = setInterval =>
        @onClickRefresh()
      , (1000 * parseInt(@autorefreshPeriod))

  onClickRefresh: ->
    @$el.find('.refresh-button').attr('disabled', true)
    @$el.find('.refresh-button i').addClass('fa-spin')
    clearInterval(@autorefreshInterval) if @autorefreshInterval
    $.ajax
      url: "/monitoring/shared_sessions/#{@sharedSessionData.id}/refresh.json"
      type: 'GET'
      global: false
      dataType: 'json'
      success: (response) =>
        @sharedSessionData = response.shared_session_data
        query = response.dashboard_session.query
        if query.analysisMode
          query.analysisMode = false
          query.exploreMode = true

        @searchQuery = new Monitoring.Models.SearchQuery(query, { use_defaults: false })

        @total = response.result.total
        @uniqueUsers = response.result.unique_users
        @facets = response.result.facets

        @accountData = response.accountData

        @refreshHeader()
        @refreshFilters()
        @refreshCharts()

        @resetAutorefreshInterval()
        @$el.find('.refresh-button i').removeClass('fa-spin')
        @$el.find('.refresh-button').removeAttr('disabled')
      error: (response) =>
        console.log("error refreshing")
        @resetAutorefreshInterval()

  onClickFilter: ->
    @$el.find('.filter-button-container').toggleClass('with-expanded-sidebar')
    @$el.find('.filter-button-container .filter-icon').toggleClass('fa-filter').toggleClass('fa-angle-left').toggleClass('fa-bold').toggleClass('fa-2x')
    @sidebarView.toggle()

  getFiltersViewOptions: ->
    {
      searchQuery: @searchQuery
      facets: @facets
      postFacets: @postFacets
      topics: @searchQuery.get('topics') || []
      tagsByClientCode: @tagsByClientCode
      searchMethod: 'search'
      isReplyFilter: false
      sortedAvailableChannelsByProvider: []
    }

  refreshHeader: ->
    @$el.find('.results-total').html(@total)
    @$el.find('.unique-users-total').html(@uniqueUsers)

  refreshFilters: ->
    @sidebarView.refresh(@getFiltersViewOptions())

  refreshCharts: ->
    @renderCharts()
